import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Paper, Typography } from '@mui/material';
import { useStateIfMounted } from 'use-state-if-mounted';
import {
    ObtenerClientePorLogin05,
    actualizarFC_05PaginaActiva,
    agregarFC_05Accion, resetDataFC_05,
    obtenerContadorDeFechaFolio,
    guardarCambiosFC_05SolicitudNueva, guardarCambiosFC_05SolicitudBorrador,
    actualizarFC_05Estatus, actualizarFC_05SolicitudBorrador,
    agregarFC_05SolicitudBorrador, actualizarModoBorradorFC_05, setModoCorrecionFC_05
} from '../../../redux/DucksBeneficiario/FC_05Ducks';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import estilos from './FormularioFC05BeneficiarioComponent.module.css';
const { useState, useRef } = React;
import InfoBar from '../../App/InfoBar'
import Collapsible from 'react-collapsible';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import DocumentacionFC_05Component from './DocumentacionFC_05Component';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import TerminosYCondicionesComponent from './TerminosYCondicionesComponent';
import { Formik } from 'formik'
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';

function FormularioFC05BeneficiarioComponent(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    let fc_05 = useSelector(store => store.FC_05Solicitud.fc_05)
    const modoEdicionBorrador = useSelector(store => store.FC_05Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_05Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_05Solicitud.data)
    const idUsuario = usuario.data.user[0].id
    let fc_05Map = useSelector(store => store.FC_05Solicitud.fc_05Map)
    let dataCliente = useSelector(store => store.FC_05Solicitud.cliente)
    var fechaHoy = moment().format('YYYY-MM-DD')
    const idlogin = idUsuario
    const store = useSelector(store => store)
    let dataLogin = useSelector(store => store.FC_05Solicitud.dataLogin)
    const currentUser = useSelector(store => store.Usuario.data)
    React.useEffect(() => {
        if (!(JSON.stringify({}) !== JSON.stringify(fc_05Map))) {
            setModoCorrecionFC_05(true)
        }
    }, [])
    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin05({ idlogin: usuario.data.user[0].id }))
    }, [])
    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_05 = data
        }
    }, [fc_05, data])

    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')

    const handleOpenModal = (data) => {

        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()
    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p className={`${estilos.bodyModal}`}>{bodyModal}</p> <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'enviarSolicitudFC_05':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        functionResetForm.function()
                                        break;
                                    case 'enviarSolicitudBorradorFC_05':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const handleResetAllPropertys = () => {
        handleCloseModal()
        dispatch(resetDataFC_05())
    }

    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const botonEnviarSolicitudFC_05 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudFC_05'
        })
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores
                Los archivos de la seccion final no se guardarán puesto que es un borrador del formulario`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarSolicitudBorradorFC_05 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_05'
        })
    }

    const botonEnviarCorreccionesFC_05 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }

    const botonRegistrarFC_05 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            correoelectronico: dataCliente.correoelectronico, telefono: dataCliente.telefono,
            embalaje: valores.embalaje, facturas: valores.facturas, folletostripticos: valores.folletostripticos,
            paginaweb: valores.paginaweb, espectaculares: valores.espectaculares, rotuladoparedes: valores.rotuladoparedes,
            otrosdocumentos: valores.otrosdocumentos, especificacionesotrosdocumentos: valores.especificacionesotrosdocumentos,
            idestatusdesolicitudes: 7, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }
        const resultado = await dispatch(agregarFC_05Accion(solicitud))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_05())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            correoelectronico: dataCliente.correoelectronico, telefono: dataCliente.telefono,
            embalaje: valores.embalaje, facturas: valores.facturas, folletostripticos: valores.folletostripticos,
            paginaweb: valores.paginaweb, espectaculares: valores.espectaculares, rotuladoparedes: valores.rotuladoparedes,
            otrosdocumentos: valores.otrosdocumentos, especificacionesotrosdocumentos: valores.especificacionesotrosdocumentos,
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        const resultado = await dispatch(agregarFC_05Accion(solicitud))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_05())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechaHoy).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc05_solicitudusomarcaeimagen: data.idfc05_solicitudusomarcaeimagen,
            embalaje: valores.embalaje, facturas: valores.facturas, folletostripticos: valores.folletostripticos,
            paginaweb: valores.paginaweb, espectaculares: valores.espectaculares, rotuladoparedes: valores.rotuladoparedes,
            otrosdocumentos: valores.otrosdocumentos, especificacionesotrosdocumentos: valores.especificacionesotrosdocumentos,
            idestatusdesolicitudes: 1,
        }

        const resultado = await dispatch(actualizarFC_05SolicitudBorrador(solicitud))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_05())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc05_solicitudusomarcaeimagen: data.idfc05_solicitudusomarcaeimagen,
            embalaje: valores.embalaje, facturas: valores.facturas, folletostripticos: valores.folletostripticos,
            paginaweb: valores.paginaweb, espectaculares: valores.espectaculares, rotuladoparedes: valores.rotuladoparedes,
            otrosdocumentos: valores.otrosdocumentos, especificacionesotrosdocumentos: valores.especificacionesotrosdocumentos,
            idestatusdesolicitudes: 7,
        }

        const resultado = await dispatch(actualizarFC_05SolicitudBorrador(solicitud))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc05_solicitudusomarcaeimagen
            const estatusNuevo = 7
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_05 = 1
            const tabla = tablaFC_05
            await dispatch(actualizarFC_05Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_05())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy)?.toISOString()
        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc05_solicitudusomarcaeimagen: data.idfc05_solicitudusomarcaeimagen,
            embalaje: valores.embalaje, facturas: valores.facturas, folletostripticos: valores.folletostripticos,
            paginaweb: valores.paginaweb, espectaculares: valores.espectaculares, rotuladoparedes: valores.rotuladoparedes,
            otrosdocumentos: valores.otrosdocumentos, especificacionesotrosdocumentos: valores.especificacionesotrosdocumentos,
            idestatusdesolicitudes: 6,
        }

        const resultado = await dispatch(actualizarFC_05SolicitudBorrador(solicitud))
        const idSolicitud = data.idfc05_solicitudusomarcaeimagen
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_05 = 1
        const tabla = tablaFC_05
        await dispatch(actualizarFC_05Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_05())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }
    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const paginaActiva = useSelector(store => store.FC_05Solicitud.paginaActiva)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Documentación'])
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            if (JSON.stringify(fc_05Map) !== '{}') { dispatch(setModoCorrecionFC_05(true)) }
            dispatch(actualizarFC_05PaginaActiva(paginaActiva + 1))
        }
    }
    const paginaAnterior = async () => {
        if (JSON.stringify(fc_05Map) !== '{}') { dispatch(setModoCorrecionFC_05(true)) }
        dispatch(actualizarFC_05PaginaActiva(paginaActiva - 1))
    }
    const validation = values => {
        let errores = {};
        const textoCheck = 'Debe de seleccionar al menos una opción'
        if (paginaActiva === 1) {
            if (!values.embalaje && !values.facturas && !values.folletostripticos &&
                !values.paginaweb && !values.espectaculares && !values.rotuladoparedes &&
                !values.otrosdocumentos) {
                errores.embalaje = textoCheck
            }
        }
        return errores;
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_05
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_05(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row mt-3'>
                                <div className='row'>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-12 marginsitoTop">
                                        <InfoBar nombreSolicitud={'Solicitud de uso de marca e imagen corporativa COMERCAM'} />
                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                    botonGuardarComoBorrador(values)}
                                            >
                                                <SaveIcon />
                                                {
                                                    modoEdicionBorrador ? (
                                                        <div className="badge text-dark textoNormal textoModal">
                                                            Guardar cambios en borrador
                                                        </div>) : (
                                                        <div className="badge text-dark textoNormal textoModal">
                                                            Guardar como borrador
                                                        </div>
                                                    )
                                                }
                                            </IconButton>
                                        </div>
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 text-center marginsitoTop">
                                        <h1></h1>
                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1 text-center marginsitoTop">
                                            <Fragment>
                                                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                    aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() => { botonReiniciarFormato(), setFunctionResetForm({ function: resetForm }) }}
                                                >
                                                    <FormatClearIcon />
                                                    <div className="badge text-dark textoNormalbadge text-dark textoModal text-center">Reiniciar Formato </div>
                                                </IconButton>
                                            </Fragment>
                                        </div>
                                    }
                                </div>
                            </div>


                            {paginaActiva === 1 ?
                                <div className='row '>
                                    <div className='row'>
                                        <h6 className={`${estilos.labelNaranja}`}>La marca y el logotipo de COMERCAM se utilizará para publicidad en</h6>
                                    </div>
                                    <div className={`row  ${estilos.divSoloBorderNaranja} mt-2 text-start`}>

                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2'>
                                            <input className={`form-check-input me-1 ${fc_05Map.embalajecheck !== undefined ? (
                                                fc_05Map?.embalajecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.embalaje} id='embalaje'
                                                name="embalaje"
                                                onChange={e => {
                                                    const { ...newValues } = values
                                                    newValues.embalaje = e.target.checked
                                                    setValues(newValues)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                Embalaje
                                            </label><br />
                                            <span className='text-danger'>{fc_05Map?.embalajecheck ? fc_05Map?.embalaje : ''}</span>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2'>
                                            <input className={`form-check-input me-1 ${fc_05Map.facturascheck !== undefined ? (
                                                fc_05Map?.facturascheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.facturas} id='facturas'
                                                name="facturas"
                                                onChange={e => {
                                                    const { ...newValues } = values
                                                    newValues.facturas = e.target.checked
                                                    setValues(newValues)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                Facturas
                                            </label><br />
                                            <span className='text-danger'>{fc_05Map?.facturascheck ? fc_05Map?.facturas : ''}</span>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2'>
                                            <input className={`form-check-input me-1 ${fc_05Map.folletostripticoscheck !== undefined ? (
                                                fc_05Map?.folletostripticoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.folletostripticos} id='folletostripticos'
                                                name="folletostripticos"
                                                onChange={e => {
                                                    const { ...newValues } = values
                                                    newValues.folletostripticos = e.target.checked
                                                    setValues(newValues)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                Folletos y/o Tríptico
                                            </label><br />
                                            <span className='text-danger'>{fc_05Map?.folletostripticoscheck ? fc_05Map?.folletostripticos : ''}</span>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3'>
                                            <input className={`form-check-input me-1 ${fc_05Map.paginawebcheck !== undefined ? (
                                                fc_05Map?.paginawebcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.paginaweb} id='paginaweb'
                                                name="paginaweb"
                                                onChange={e => {
                                                    const { ...newValues } = values
                                                    newValues.paginaweb = e.target.checked
                                                    setValues(newValues)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                Página web
                                            </label><br />
                                            <span className='text-danger'>{fc_05Map?.paginawebcheck ? fc_05Map?.paginaweb : ''}</span>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3'>
                                            <input className={`form-check-input me-1 ${fc_05Map.espectacularescheck !== undefined ? (
                                                fc_05Map?.espectacularescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.espectaculares} id='espectaculares'
                                                name="espectaculares"
                                                onChange={e => {
                                                    const { ...newValues } = values
                                                    newValues.espectaculares = e.target.checked
                                                    setValues(newValues)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                Espectaculares
                                            </label><br />
                                            <span className='text-danger'>{fc_05Map?.espectacularescheck ? fc_05Map?.espectaculares : ''}</span>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3'>
                                            <input className={`form-check-input me-1 ${fc_05Map.rotuladoparedescheck !== undefined ? (
                                                fc_05Map?.rotuladoparedescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.rotuladoparedes} id='rotuladoparedes'
                                                name="rotuladoparedes"
                                                onChange={e => {
                                                    const { ...newValues } = values
                                                    newValues.rotuladoparedes = e.target.checked
                                                    setValues(newValues)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                Rotulado en paredes
                                            </label><br />
                                            <span className='text-danger'>{fc_05Map?.rotuladoparedescheck ? fc_05Map?.rotuladoparedes : ''}</span>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3'>
                                            <input className={`form-check-input me-1 ${fc_05Map.otrosdocumentoscheck !== undefined ? (
                                                fc_05Map?.otrosdocumentoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                checked={values.otrosdocumentos} id='otrosdocumentos'
                                                name="otrosdocumentos"
                                                onChange={e => {
                                                    const { ...newValues } = values
                                                    newValues.otrosdocumentos = e.target.checked
                                                    setValues(newValues)
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                Otros documentos
                                            </label><br />
                                            <span className='text-danger'>{fc_05Map?.otrosdocumentoscheck ? fc_05Map?.otrosdocumentos : ''}</span>
                                        </div>
                                        {
                                            values.otrosdocumentos ?
                                                <div className='col-md-8'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_05Map.especificacionesotrosdocumentoscheck !== undefined ? (
                                                            fc_05Map?.especificacionesotrosdocumentoscheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            placeholder='especificacionesotrosdocumentos'
                                                            name="especificacionesotrosdocumentos"
                                                            value={values.especificacionesotrosdocumentos}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label htmlFor="floatingInput">Especificar</label>
                                                        <span className='text-danger'>{fc_05Map?.especificacionesotrosdocumentoscheck ? fc_05Map?.especificacionesotrosdocumentos : ''}</span>
                                                        {touched.especificacionesotrosdocumentos && errors.especificacionesotrosdocumentos && <div className="text-danger">{errors.especificacionesotrosdocumentos}</div>}
                                                    </div>
                                                </div>
                                                : ''
                                        }
                                        <br />
                                        {<div className="text-danger text-center">{errors.embalaje}</div>}
                                        <label className='mt-2 justify-content-start'><b>Nota:</b> Se Anexará a la presente solicitud una muestra del diseño de la publicidad de las opciones seleccionadas</label>
                                    </div>
                                </div>
                                :
                                <Fragment>
                                    <br />
                                    {
                                        modoCorreccion &&
                                        <div className={`row col-md-12`} style={{ marginLeft: '-8%' }}>
                                            <DocumentacionFC_05Component> </DocumentacionFC_05Component>
                                        </div>
                                    }
                                    <div className='row justify-content-start'>
                                        <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_05'} />
                                    </div>
                                    <br />
                                    {!modoCorreccion ?
                                        <div>
                                            <div className="row mt-4">
                                                {
                                                    modoEdicionBorrador ? (
                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                            <button type="submit"
                                                                onClick={() => { botonEnviarSolicitudBorradorFC_05(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                        </div>
                                                    ) : (
                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                            <button type="submit"
                                                                onClick={() => { botonEnviarSolicitudFC_05(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                disabled={!terminosYCondiciones}>Enviar</button>
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </div>
                                        :
                                        <div className="row mt-4">
                                            <div className="d-grid gap-2 col-2 mx-auto">
                                                <button type="submit"
                                                    onClick={() => { botonEnviarCorreccionesFC_05(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                    className={`btn ${estilos.botonNaranjaEn}`}
                                                    disabled={!terminosYCondiciones}>Enviar correcciones</button>
                                            </div>
                                        </div>
                                    }
                                </Fragment>}

                            {/*FilesGenerales()*/}


                            <br />
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                        </div>
                    </form>
                )}
            </Formik>
        </Fragment>
    )
}
export default withRouter(FormularioFC05BeneficiarioComponent)